import { func } from 'prop-types';
import { domain } from '../i18n';

export function processCountryPhone() {
    const domainLast = domain;
    return domainLast === 'com' ? 'ca' : domainLast;
}

export function detectPhone() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    let value = false;
    if (/android/i.test(userAgent)) {
        value = true;
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        value = true;
    } else if (window.innerWidth <= 768) {
        value = true;
    }
    return value;
}
